/**
 * TanStack Query hooks for `referral-partner`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	referralPartnerQueryKeys,
	type CreateReferralPartnerBody,
	type ListReferralPartnerResponse,
	type ReferralPartnerRow,
} from "./api";

export function useReferralPartnerList(): UseQueryResult<ListReferralPartnerResponse, Error> {
	return useQuery({
		queryKey: referralPartnerQueryKeys.list(),
		queryFn: list,
	});
}

export function useReferralPartnerCreate(): UseMutationResult<ReferralPartnerRow, Error, CreateReferralPartnerBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: referralPartnerQueryKeys.all });
		},
	});
}

export function useReferralPartnerDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: referralPartnerQueryKeys.all });
		},
	});
}
